/**
 * Web Style Import
 *
 */

import './style/index'
